// Copyright (c) 2017 Deere & Company

import {
    getReportLayouts,
    hideReportColumn,
    resetReportVariant,
    updateDefaultLayout,
    updateReportProperty
} from '../../../reports/shared/action-creators/report-variant';
import {
    resetReportIsScrollable,
    toggleReportIsScrollable
} from '../../shared/action-creators/reset-report-is-scrollable';
import {
    selectAllDealersOnLoad,
    selectAllOpenPipsDealers,
    selectOpenPipsReportDealer
} from './select-dealer';
import {
    selectAllPipMetrics,
    selectMetric
} from './select-metric';
import {
    selectAllPipStatuses,
    selectPipStatuses
} from './select-pip-statuses';
import {createAgGridApi} from '../../shared/action-creators/create-ag-grid';
import {createPipProgramsReport} from './create-report';
import {readMetrics} from './read-metrics';
import {readPipStatuses} from './read-pip-statuses';
import {resetMetrics} from './reset-metrics';
import {resetPipStatuses} from './reset-pip-statuses';
import {resetSearchResults} from '../../shared/action-creators/reset-search-results';
import {updateIncludeFullyComplete} from './update-include-fully-complete';
import {updatePipNumber} from './update-pip-number';
import {updateShowNoResultsFound} from '../../shared/action-creators/show-no-results-found';

export default {
    createAgGridApi,
    createPipProgramsReport,
    getReportLayouts,
    hideReportColumn,
    readMetrics,
    readPipStatuses,
    resetMetrics,
    resetPipStatuses,
    resetReportIsScrollable,
    resetReportVariant,
    resetSearchResults,
    selectAllDealersOnLoad,
    selectAllOpenPipsDealers,
    selectAllPipMetrics,
    selectAllPipStatuses,
    selectMetric,
    selectOpenPipsReportDealer,
    selectPipStatuses,
    toggleReportIsScrollable,
    updateDefaultLayout,
    updateIncludeFullyComplete,
    updatePipNumber,
    updateReportProperty,
    updateShowNoResultsFound
};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/index.js